import React, { useState, useEffect } from 'react';
import { getSingleTemplet } from "../../../ReduxStore/Slice/Templets/EmailTemplet";
import { useDispatch } from 'react-redux';
import Datatable from '../../../ExtraComponents/ReusableTable1';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';

import Swal from 'sweetalert2';
import { StripHtmlAndTruncate } from "../../../Utils/CommonFun";

const History = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));

    const [getHistoryData, setHistoryData] = useState([]);

    useEffect(() => {
        viewHistory();
    }, []);

    const viewHistory = async () => {
        const req = { id: location?.state?.row?.id || location?.state?.id, agent_id: agent_id };
        await dispatch(getSingleTemplet(req)).unwrap()
            .then((response) => {
                if (response.status) {
                    setHistoryData(response.data.EmailTemplateHistories || []);
                } else {
                    setHistoryData([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching template history:", error);
            });
    };

    const DateFormat = (newDate) => {
        if (!newDate) return "-";
        const date = new Date(newDate);
        return format(date, 'eee, MMM d, yyyy h:mm a');
    };

    const columns = [
    {
      name: "History",
      cell: (row) => (
        <>
          <div>
            <p>
              {row.history}
            </p>
            <p>
              {DateFormat(row?.createdAt)}
            </p>
          </div>

        </>
      ),
      selector: (row) => row.history,
      sortable: true,
    },
        {
            name: "Description",
            cell: (row) => {
                const { truncated, isTruncated, fullText } = StripHtmlAndTruncate(row?.description || "");
                return (
                    <div>
                        {truncated}
                        {isTruncated && (
                            <span 
                                className="text-pink cursor-pointer ms-1" 
                                onClick={() => {
                                    Swal.fire({
                                        title: 'Full Description',
                                        text: fullText,
                                        confirmButtonColor: '#ff00a2'
                                    });
                                }}
                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                            >
                                Read More
                            </span>
                        )}
                    </div>
                );
            },
            selector: (row) => row.description,
            sortable: true,
        },
    ];

    return (
        <div className="card mt-2">
            <div className="card-body">
                <section className="section dashboard">
                    <div className="row">
                        <div className='dark-table-thead'>
                            <Datatable
                                columns={columns}
                                data={getHistoryData}
                                filter={false}
                            />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default History;
